import { useState } from "react";

import { useStore } from "../store.js";

const inputClass =
  "w-full rounded-lg border border-node-border bg-canvas px-3 py-2 text-sm text-ink outline-none focus:border-accent";

/** A calm confirmation for a pending grouping action. Nothing groups until the
 * user says yes here. Mounted only while a prompt is pending. */
export function ConfirmDialog() {
  const prompt = useStore((state) => state.groupPrompt);
  const setGroupPrompt = useStore((state) => state.setGroupPrompt);
  const createGroup = useStore((state) => state.createGroup);
  const addToGroup = useStore((state) => state.addToGroup);

  const [name, setName] = useState("New group");

  if (!prompt) {
    return null;
  }

  function cancel() {
    setGroupPrompt(null);
  }

  function confirm() {
    if (!prompt) {
      return;
    }
    if (prompt.kind === "add") {
      void addToGroup(prompt.groupId, [prompt.nodeId]);
    } else {
      const trimmed = name.trim();
      void createGroup(trimmed || "New group", prompt.nodeIds);
    }
    setGroupPrompt(null);
  }

  return (
    <div className="fixed inset-0 z-40 flex items-center justify-center bg-black/40 p-6">
      <div className="w-full max-w-sm rounded-2xl border border-node-border bg-node-bg p-6 shadow-2xl">
        {prompt.kind === "add" ? (
          <>
            <h2 className="text-base font-semibold text-ink">Add to group?</h2>
            <p className="mt-2 text-sm text-ink-muted">
              Add <span className="text-ink">{prompt.nodeName}</span> to{" "}
              <span className="text-ink">{prompt.groupName}</span>?
            </p>
          </>
        ) : (
          <>
            <h2 className="text-base font-semibold text-ink">Group these nodes?</h2>
            <p className="mt-2 text-sm text-ink-muted">
              Group <span className="text-ink">{prompt.nodeNames[0]}</span> and{" "}
              <span className="text-ink">{prompt.nodeNames[1]}</span> together.
            </p>
            <label className="mt-4 block text-xs text-ink-muted" htmlFor="group-name">
              Group name
            </label>
            <input
              id="group-name"
              autoFocus
              className={`${inputClass} mt-1`}
              value={name}
              onChange={(event) => setName(event.target.value)}
              onKeyDown={(event) => {
                if (event.key === "Enter") confirm();
              }}
            />
          </>
        )}

        <div className="mt-6 flex justify-end gap-2">
          <button
            type="button"
            onClick={cancel}
            className="rounded-lg border border-node-border px-3 py-1.5 text-sm text-ink-muted hover:text-ink"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={confirm}
            className="rounded-lg bg-accent px-4 py-1.5 text-sm font-medium text-canvas hover:opacity-90"
          >
            {prompt.kind === "add" ? "Add" : "Group"}
          </button>
        </div>
      </div>
    </div>
  );
}
